import { mountStoreDevtool } from 'simple-zustand-devtools'
import { Group } from 'types/grupos'
import { create } from 'zustand'
import { combine, persist, createJSONStorage } from 'zustand/middleware'

type GrupoInfo = {
  grupo: Group
  grupo_id: number | undefined
  grupo_cotas_vagas: Record<number, number>
  selected_group: Group | null
}

const DEFAULT_GRUPO_INFO: GrupoInfo = {
  grupo: {} as Group,
  grupo_id: undefined,
  grupo_cotas_vagas: {} as Record<number, number>,
  selected_group: null
}

const useGrupoStore = create(
  persist(
    combine(DEFAULT_GRUPO_INFO, (set) => ({
      setGrupo: (grupo: Group) => set({ grupo }),
      setGrupoCotasVagas: (cotasVagas: Record<number, number>) =>
        set({ grupo_cotas_vagas: cotasVagas }),
      setSelectedGroup: (grupo: Group | null) => set({ selected_group: grupo }), // usado só para colorir os cars/ remover no futuro
      resetGrupo: () => {
        localStorage.removeItem('grupo-storage-2')
        set(DEFAULT_GRUPO_INFO)
      }
    })),
    {
      name: 'grupo-storage-2',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Loja Grupo', useGrupoStore)
}

export default useGrupoStore
